export const LIST_INDUSTRIES = 'industryList'
export const IS_GOOGLE_CONNECTED = 'isGoogleConnected'



// WEBPACK FOOTER //
// ./src/store/getter.types.js